export default __webpack_public_path__ + "static/media/non_profit.6cf80ceb.svg";